var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99965 10.1698L2.52965 6.69982C2.13965 6.30982 1.50965 6.30982 1.11965 6.69982C0.729648 7.08982 0.729648 7.71982 1.11965 8.10982L5.29965 12.2898C5.68965 12.6798 6.31965 12.6798 6.70965 12.2898L17.2896 1.70982C17.6796 1.31982 17.6796 0.689824 17.2896 0.299824C16.8997 -0.0901758 16.2696 -0.0901758 15.8796 0.299824L5.99965 10.1698Z",
    fill: "#03CE91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.613a182475cd0d3fb96fd73fb632dfee.svg";
export { ForwardRef as ReactComponent };